import { Button, Modal } from '../../../../components'
import { DeleteLeaveTypeIProps } from '../../../leavepolicy/leavetypes/types'
// import { useNavigate } from 'react-router-dom'
import '../../pages/index.css'
import { deleteLeaveTypes } from '../../leavetypes/api'
import { useAppDispatch } from '../../../../redux/hook'
import { SHOW_NOTIFICATION } from '../../../../redux/slices/showNotificationSlice'
import { HIDE_LOADER, SHOW_LOADER } from '../../../../redux/slices/LoaderSlice'
import { deleteLeaveType } from '../../leavetypes/slice/index'
import { deleteLeavePolicyDetails } from '../../editpolicy/api'
import { deleteLeavePolicy } from '../../../leavepolicy/slice/index'

const DelLeaveType = ({
    show,
    onClose,
    deleteLeaveTypeId,
    deleteLeavePolicyId,
}: DeleteLeaveTypeIProps) => {
    // const navigate = useNavigate()
    const dispatch = useAppDispatch()

    const handleDeleteLeaveType = async () => {
        if (!deleteLeaveTypeId) {
            console.error('Leave type ID is undefined')
            return
        }

        try {
            dispatch(SHOW_LOADER())
            const response = await deleteLeaveTypes(deleteLeaveTypeId)
            if (response?.status === 200) {
                dispatch(
                    SHOW_NOTIFICATION({
                        message: 'Leave type deleted successfully',
                        type: 'success',
                    })
                )
                dispatch(deleteLeaveType(deleteLeaveTypeId))
            }
        } catch (error) {
            dispatch(
                SHOW_NOTIFICATION({
                    message: 'Something went wrong',
                    type: 'error',
                })
            )
            console.error('Error deleting leave type:', error)
        } finally {
            dispatch(HIDE_LOADER())
            onClose(false)
        }
    }

    const handleDelete = async () => {
        if (!deleteLeavePolicyId) {
            console.error('deleteLeavePolicyId is undefined')
            dispatch(
                SHOW_NOTIFICATION({
                    message: 'Leave Policy ID is missing',
                    type: 'error',
                })
            )
            return
        }

        dispatch(SHOW_LOADER())
        const requestBody = {
            leavePolicyId: deleteLeavePolicyId,
        }

        try {
            const response = await deleteLeavePolicyDetails(requestBody)
            dispatch(deleteLeavePolicy(deleteLeavePolicyId))

            if (response?.status === 200) {
                dispatch(
                    SHOW_NOTIFICATION({
                        message: 'Leave Policy deleted successfully',
                        type: 'success',
                    })
                )
            }
        } catch (error) {
            console.error(error)
            dispatch(
                SHOW_NOTIFICATION({
                    message: 'Failed to delete Leave Policy',
                    type: 'error',
                })
            )
        } finally {
            dispatch(HIDE_LOADER())
            onClose(false)
        }
    }

    return (
        <Modal
            show={show}
            handleClose={() => onClose(false)}
            title={
                deleteLeavePolicyId
                    ? 'Delete Leave Policy'
                    : 'Delete Leave Type'
            }
            body={
                <>
                    <p className="del-desc">
                        {deleteLeavePolicyId
                            ? 'Are you sure you want to delete this leave policy ?'
                            : 'Are you sure you want to delete this leave type ?'}
                    </p>
                    <div className="footer-block">
                        <Button
                            type="submit"
                            onClick={
                                deleteLeavePolicyId
                                    ? handleDelete
                                    : handleDeleteLeaveType
                            }
                        >
                            YES
                        </Button>
                        <Button
                            type="button"
                            variant="outline-success"
                            onClick={() => onClose(false)}
                        >
                            NO
                        </Button>
                    </div>
                </>
            }
            onSuccess={() => {
                onClose(false)
            }}
        />
    )
}
export default DelLeaveType
